import 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

const GalleryModule = {
  firestorePath: 'galleries',
  firestoreRefType: 'collection',
  moduleName: 'GalleryModule',
  statePropName: 'galleries',
  namespaced: true,
  sync: {
    defaultValues: {
      ownerId: '',
      name: '',
      description: '',
      archived: false,
      featuredImage: '',
      items: [],
      users: []
    }
  },
  getters: {
    get: (state) => {
      return Object.values(state.galleries).filter(item => !item.archived)
    },
    getArchived: (state) => {
      return Object.values(state.galleries).filter(item => item.archived)
    },
    getById: (state) => (id) => {
      var galleries = Object.values(state.galleries)
      var gallery = {name: '', description: ''}
      for (var i = 0; i < galleries.length; i++) {
        gallery = galleries[i]
        if (gallery.id === id) {
          break
        }
      }

      return gallery
    }
  },
  actions: {
    create: ({dispatch}, payload) => {
      var gallery = {
        name: payload.name
      }

      dispatch('insert', gallery)
    },
    save: ({dispatch}, payload) => {
      var gallery = {
        id: payload.id,
        name: payload.name
      }

      dispatch('patch', gallery)
    },
    shareGallery: ({dispatch}, payload) => {
      if (payload.gallery.users.indexOf(payload.user) == -1) {
        payload.gallery.users.push(payload.user)
        dispatch('patch', {id: payload.gallery.id, users: payload.gallery.users})
      }
    },
    unshareGallery: ({dispatch}, payload) => {
      var index = payload.gallery.users.indexOf(payload.user)
      payload.gallery.users.splice(index, 1)

      dispatch('patch', {id: payload.gallery.id, users: payload.gallery.users})
    },
    archive: ({dispatch}, payload) => {
      dispatch('patch', {id: payload.id, archived: true})
    },
    saveItemOrder: ({dispatch}, payload) => {
      dispatch('patch', {id: payload.id, items: payload.items})
    },
    addToGallery: async ({dispatch}, payload) => {
      if (payload.gallery.items.indexOf(payload.itemId) == -1) {
        payload.gallery.items.push(payload.itemId)
        dispatch('patch', {id: payload.gallery.id, items: payload.gallery.items})
      }
    },
    removeFromGallery: async ({dispatch}, payload) => {
      var index = payload.gallery.items.indexOf(payload.itemId)
      payload.gallery.items.splice(index, 1)

      dispatch('patch', {id: payload.gallery.id, items: payload.gallery.items})
    },
    // saveItems: async ({dispatch, getters}, payload) => {
    //   var gallery = getters.getById(payload.galleryId)

    //   var items = []
    //   for (var i = 0; i < payload.itemIds.length; i++) {
    //     var itemId = payload.itemIds[i].id
    //     if (!gallery.items.indexOf(itemId)) {
    //       items.push(itemId)
    //     }
    //   }

    //   gallery.items = payload.items

    //   dispatch('patch', gallery)
    // },
    removePhoto: ({dispatch}, payload) => {
      var index = payload.gallery.items.indexOf(payload.itemId)
      payload.gallery.items.splice(index, 1)

      dispatch('patch', {id: payload.gallery.id, items: payload.gallery.items})
    }
  }
}

export default GalleryModule